import {getToken} from "../helpers/Token.helper";

export const interceptor = ({
    request: async (url, config) => {
        const token = getToken();
        console.log(config);
        if(token){
            config.headers.Authorization = `Bearer ${token}`;
        }
        return [url, config];
    },
    response: (response) => {
        return response;
    },
    responseError: (error) => {
        return Promise.reject(error);
    }
});
